import { useEffect, useState } from "react";
import { MessageCircle, Save } from "lucide-react";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";

export default function AdminSettings() {
  const [whatsapp, setWhatsapp] = useState("");
  const [config, setConfig] = useState({ dummy_payment: true });
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/admin/settings").then((r) => setWhatsapp(r.data.whatsapp_number || "")).catch(() => {});
    api.get("/config").then((r) => setConfig(r.data)).catch(() => {});
  }, []);

  const save = async () => {
    setSaving(true);
    try {
      await api.put("/admin/settings", { whatsapp_number: whatsapp.trim() });
      toast.success("Settings saved");
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="max-w-2xl">
      <h1 className="font-display text-2xl font-bold mb-1">Settings</h1>
      <p className="text-sm text-muted-foreground mb-6">Manage your store configuration.</p>

      <div className="bg-card border border-border rounded-2xl p-6">
        <h2 className="font-semibold flex items-center gap-2 mb-4"><MessageCircle className="w-4 h-4 text-primary" /> WhatsApp Orders</h2>
        <label className="text-sm text-foreground">Business WhatsApp Number</label>
        <input value={whatsapp} onChange={(e) => setWhatsapp(e.target.value)} placeholder="e.g. 919812345678 (with country code)" data-testid="settings-whatsapp"
          className="mt-1.5 w-full rounded-xl bg-secondary border border-input px-3 py-2.5 text-sm text-foreground outline-none focus:border-primary" />
        <p className="text-xs text-muted-foreground mt-2">Customers' "Order on WhatsApp" enquiries are sent to this number. Include the country code (e.g. 91 for India) so it opens correctly.</p>
        <button onClick={save} disabled={saving} className="mt-5 inline-flex items-center gap-2 bg-primary text-primary-foreground rounded-full px-6 py-2.5 text-sm font-semibold disabled:opacity-60" data-testid="settings-save-btn">
          <Save className="w-4 h-4" /> {saving ? "Saving…" : "Save"}
        </button>
      </div>

      <div className="bg-card border border-border rounded-2xl p-6 mt-5">
        <h2 className="font-semibold mb-3">Payments</h2>
        <div className="flex items-center justify-between text-sm">
          <span className="text-muted-foreground">Razorpay online payments</span>
          <span className={`rounded-full px-3 py-1 text-xs font-semibold ${config.dummy_payment ? "bg-amber-500/20 text-amber-400" : "bg-emerald-500/20 text-emerald-400"}`}>
            {config.dummy_payment ? "TEST / DUMMY MODE" : "LIVE"}
          </span>
        </div>
        <p className="text-xs text-muted-foreground mt-3">
          {config.dummy_payment
            ? "No Razorpay keys are set yet, so online orders are auto-marked paid for demos. Turn Online off under Payment Methods to hide it from checkout."
            : "Live Razorpay keys are active. Real payments are being processed."}
        </p>
      </div>
    </div>
  );
}
